import { render, staticRenderFns } from "./EdgeDetail.vue?vue&type=template&id=5e18460c&scoped=true&"
import script from "./EdgeDetail.vue?vue&type=script&lang=ts&"
export * from "./EdgeDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e18460c",
  null
  
)

export default component.exports